module.exports = __webpack_public_path__ + "img/ticket.0011e26a.png";